module.exports = __webpack_public_path__ + "static/img/cont2203.a561835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2203.jpg
// module id = 1mZG
// module chunks = 0